;(function (window, document) {
	'use strict';

	var  nextTick, addEvent;
	nextTick = window.requestAnimationFrame ||
			   window.mozRequestAnimationFrame ||
			   window.webkitRequestAnimationFrame ||
			   function (callback) {
				   window.setTimeout(callback, 1000 / 60);
			   };

	addEvent = (function(){
		if (document.addEventListener){
			return function addStandardEventListener(el, eventName, fn){
				return el.addEventListener(eventName, fn, false);
			};
		}
		else {
			return function addIEEventListener(el, eventName, fn){
				return el.attachEvent('on'+eventName, fn);
			};
		}
	})();

	function Imager (elements, opts) {
		var self = this,doc  = document;
		opts = opts || {};

		this.elements         = elements || '.js-responsive-image';
		this.className        = opts.className || 'js-responsive-image-replaced';
		this.onResize         = opts.hasOwnProperty('onResize') ? opts.onResize : true;
		this.onImagesReplaced = opts.onImagesReplaced || function () {};

		this.eles = $(elements);
		nextTick(function(){self.init();});
	}

	Imager.prototype.init = function(){
		this.checkImagesNeedReplacing(this.eles);
		if(this.onResize){this.registerResizeEvent();}
        this.registerImageExpanderClickEvent();
	};

	Imager.prototype.checkImagesNeedReplacing = function (images) {
		var self = this;

		if (!this.isResizing) {
			this.isResizing = true;

			images.each(function(){self.replaceImagesBasedOnScreenDimensions(this);});

			this.isResizing = false;
			this.onImagesReplaced(images);
		}
	};

	Imager.prototype.replaceImagesBasedOnScreenDimensions = function (image) {
		var src,availableWidths = [],srcARRAY,superzoom_srcARRAY,cwidth;

		if( $(image).attr("data-media")!=undefined){
			var eMedia = $(image).attr("data-media")
			$(image).removeAttr("data-media")
			eMedia = JSON.parse(eMedia)
			$.each(eMedia, function(key, value) {
				  availableWidths.push(parseInt(key));
			});
			$(image).data("width",availableWidths);
			$(image).data("media",eMedia);
		}

		if( $(image).attr("data-superzoom-media") != undefined){
			var eMedia = $(image).attr("data-superzoom-media")
			$(image).removeAttr("data-superzoom-media")
			eMedia = JSON.parse(eMedia)
			$.each(eMedia, function(key, value) {
				  availableWidths.push(parseInt(key));
			});
			$(image).data("width",availableWidths);
			$(image).data("superzoom-media",eMedia);
		}

		srcARRAY = $(image).data("media");
		superzoom_srcARRAY=$(image).data("superzoom-media");


		cwidth = Imager.getClosestValue(window.innerWidth, $.extend([],$(image).data("width")));

		if(superzoom_srcARRAY[cwidth] != undefined){
			$(image).attr("data-superzoom-src", superzoom_srcARRAY[cwidth]);
		}

		if(srcARRAY != undefined){
			if(!srcARRAY[cwidth] || image.src == srcARRAY[cwidth]){return;}
			image.src = srcARRAY[cwidth];
		}

	};

	Imager.getClosestValue = function getClosestValue(baseValue, candidates){
		if(baseValue >= candidates[0] && candidates.length > 1){
			candidates.shift()
			getClosestValue(baseValue,candidates)
		}
		return candidates[0];
	}

	Imager.prototype.registerResizeEvent = function(){
		var self = this;
		addEvent(window, 'resize', function(){
			self.checkImagesNeedReplacing(self.eles);
		});
	};

    Imager.prototype.registerImageExpanderClickEvent = function(){
		var self = this;
        var openImageBtn = document.getElementsByClassName('magic-box__img-expander')[0];
        if (openImageBtn !== undefined && openImageBtn !== null) {
            addEvent(openImageBtn, 'click', function(){
                setTimeout(() => {
                    self.checkImagesNeedReplacing(self.eles);
                }, 0);
            });
        }
	};

	if (typeof module === 'object' && typeof module.exports === 'object') {
		module.exports = exports = Imager;
	} else if (typeof define === 'function' && define.amd) {
		define(function () { return Imager; });
	} else if (typeof window === 'object') {
		window.Imager = Imager;
	}

}(window, document));
